import { WarningFilled } from '@ant-design/icons';
import { Card, Col, Row } from 'antd';
import { getActiveWithoutSchedules } from 'api/contract.api';
import {
  ActiveContractsCardProps,
  ContractsCountCardProps,
} from 'interfaces/contract.interfaces';
import { useCallback, useEffect, useState } from 'react';
import Contract, { ContractKind } from 'types/contract';

export const ActiveContracts = ({
  contractKinds,
}: ActiveContractsCardProps) => {
  const [activeContractsWithoutSchedules, setActiveContractsWithoutSchedules] =
    useState<Contract[]>([]);

  const searchActiveContractsWithouSchedules = useCallback(async () => {
    try {
      const response = await getActiveWithoutSchedules();
      setActiveContractsWithoutSchedules(response.data ?? []);
    } catch {
      setActiveContractsWithoutSchedules([]);
    }
  }, []);

  useEffect(() => {
    void searchActiveContractsWithouSchedules();
  }, [searchActiveContractsWithouSchedules]);

  const ContractsCount = ({
    contractTypeTxt,
    contractCount,
    showWarningIcon,
  }: ContractsCountCardProps) => (
    <div className="contracts-count-card text-center">
      {showWarningIcon && (
        <div className="card-warning-icon">
          <WarningFilled />
        </div>
      )}
      <span className="contracts-number">{contractCount}</span>
      <div className="contracts-type-txt">{contractTypeTxt}</div>
    </div>
  );

  return (
    <div id="active-contracts">
      <Card
        title={<h3 className="sub-title">Contratos activos</h3>}
        className="card"
      >
        <Row>
          <Col className="contracts-wrapper-dashboard" xs={24}>
            {activeContractsWithoutSchedules.length > 0 && (
              <div>
                <ContractsCount
                  contractCount={activeContractsWithoutSchedules.length}
                  contractTypeTxt="Contratos sin horarios asignados"
                  showWarningIcon
                />
              </div>
            )}
            {contractKinds &&
              contractKinds.map((contract: ContractKind) => (
                <div key={`contract-kinds-${contract._id}`}>
                  <ContractsCount
                    contractCount={contract.count}
                    contractTypeTxt={`Contratos ${contract.name}`}
                  />
                </div>
              ))}
          </Col>
        </Row>
      </Card>
    </div>
  );
};
